import {
  Behaviour,
  GameObject,
  RawImage,
  Renderer,
  Text,
  serializable,
} from "@needle-tools/engine";
import { RaceOrderManager } from "./RaceOrderManager";
import { EventData } from "./EventData";

export class UIManager extends Behaviour {
  @serializable(GameObject)
  public raceOrderObject?: GameObject;

  @serializable(RaceOrderManager)
  public raceOrderManager!: RaceOrderManager;

  @serializable(GameObject)
  public toggleCountryButtonActive?: GameObject;

  @serializable(GameObject)
  public toggleCountryButtonInactive?: GameObject;

  @serializable(GameObject)
  public bettingUI?: GameObject;

  @serializable(GameObject)
  public bettingUIEnabled?: GameObject;

  @serializable(GameObject)
  public bettingUIDisabled?: GameObject;

  @serializable(GameObject)
  public bettingUIResultsPage?: GameObject;

  @serializable(GameObject)
  public bettingUIBettingPage?: GameObject;

  @serializable(GameObject)
  public autoCamEnabledButton?: GameObject;

  @serializable(GameObject)
  public autoCamDisabledButton?: GameObject;

  @serializable(RawImage)
  public raceOrderImages?: RawImage[];

  @serializable(GameObject)
  public racerCountryIcons?: GameObject[];

  @serializable(GameObject)
  public raceOrderParent: GameObject | undefined;

  @serializable(GameObject)
  public racerButton1: GameObject | undefined;

  @serializable(GameObject)
  public racerButton2: GameObject | undefined;

  @serializable(GameObject)
  public racerButton3: GameObject | undefined;

  @serializable(GameObject)
  public racerButton4: GameObject | undefined;

  @serializable(GameObject)
  public racerButton5: GameObject | undefined;

  @serializable(GameObject)
  public racerButton6: GameObject | undefined;

  private defaultHorseInFocusText: string = "";
  private eventData: EventData | undefined;
  private horseInFocusString: string = "";

  public toggleAutoCam(isEnabled: boolean): void {
    if (isEnabled) {
      GameObject.setActive(this.autoCamEnabledButton!, true);
      GameObject.setActive(this.autoCamDisabledButton!, false);
    } else {
      GameObject.setActive(this.autoCamEnabledButton!, false);
      GameObject.setActive(this.autoCamDisabledButton!, true);
    }
  }

  public enableRaceOrderUI(): void {
    //Call via a Unity event to activate (old UI)
    if (this.raceOrderObject) {
      GameObject.setActive(this.raceOrderObject, true);
    }
  }

  public updateRacerOrderIcons(): void {
    return; //This is the old UI so not using it any more. Leaving it here in case we need to revert back to it
    // console.log("Updating racer order icons");

    // // Check if raceOrderManager and raceOrderImages are defined
    // if (!this.raceOrderManager) {
    //     console.error("RaceOrderManager is not defined");
    //     return;
    // }

    // if (!this.raceOrderImages) {
    //     console.error("RaceOrderImages is not defined");
    //     return;
    // }

    // // Get racers array
    // const racers = this.raceOrderManager.ReturnRacers();

    // // Check if racers array is defined and not empty
    // if (!racers || racers.length === 0) {
    //     console.error("No racers found");
    //     return;
    // }

    // // Check if raceOrderImages array is not empty
    // if (this.raceOrderImages.length === 0) {
    //     console.error("No race order images found");
    //     return;
    // }

    // // Iterate over racers array
    // for (let i = 0; i < racers.length && i < this.raceOrderImages.length; i++) {
    //     // Ensure racerSprite and texture are defined before setting the texture
    //     if (!racers[i].racerSprite || !racers[i].racerSprite.texture) {
    //         console.error(`Racer at index ${i} does not have a valid sprite or texture`);
    //         continue;
    //     }

    //     // Set the texture of the corresponding image based on racer's position
    //     this.raceOrderImages[i].mainTexture = racers[i].racerSprite.texture;
    // }
  }

  public toggleCountryIcons(setEnabled: boolean): void {
    if (this.racerCountryIcons) {
      for (let i = 0; i < this.racerCountryIcons.length; i++) {
        if (setEnabled == false) {
          GameObject.setActive(this.racerCountryIcons[i], false);
        } else {
          GameObject.setActive(this.racerCountryIcons[i], true);
        }
      }
    }
  }

  public resetHorseFocusText(): void {
    this.horseInFocusString = this.defaultHorseInFocusText;
  }

  public updateHorseFocusText(horseName: string): void {
    // if (this.eventData == null) {
    //   this.eventData = EventData.getInstance();
    // }

    // const horseIndex = parseInt(horseName.replace("Horse", ""), 10) - 1;
    // const competitors = this.eventData.getCompetitors();

    // const horseNameToUse =
    //   horseIndex >= 0 && horseIndex < competitors.length
    //     ? competitors[horseIndex].getName()
    //     : "";

    //If the horseName contains an underscore, replace it with a space
    if (horseName.includes("_")) {
      horseName = horseName.replace("_", " ");
    }

    this.horseInFocusString = horseName;
  }

  public returnHorseInFocusString(): string {
    return this.horseInFocusString;
  }

  public toggleBettingUI(isEnabled: boolean): void {
    if (this.bettingUI) {
      GameObject.setActive(this.bettingUI!, isEnabled);
      GameObject.setActive(this.bettingUIEnabled!, isEnabled);
      GameObject.setActive(this.bettingUIDisabled!, !isEnabled);

      if (isEnabled) {
        GameObject.setActive(this.bettingUIResultsPage!, false);
        GameObject.setActive(this.bettingUIBettingPage!, true);
      }
    }
  }

  public showBettingUIResultsPage(): void {
    // if (this.bettingUIResultsPage) {
    //   GameObject.setActive(this.bettingUIResultsPage!, true);
    //   GameObject.setActive(this.bettingUIBettingPage!, false);
    // }
    // this.toggleBettingUI(true);
    //TODO - Trigger end of race UI here
  }
}
